<section class="vh-100 gradient-custom">

  <div class="container h-100">

    <div class="row d-flex justify-content-center align-items-center h-100">

      <div class="col-12 col-md-8 col-lg-6 col-xl-5">

        <div class="card" style="border-radius: 1rem;">

          <div class="card-body p-5">

            @if (pageState == pageStateEnum.LOGIN) {

            <form (ngSubmit)="login()" #loginForm="ngForm">

              <div class="mb-md-5 mt-md-4 text-center">
                <img src="assets/images/logo-small.png" alt="Logo" class="logo rounded mb-4" />
                <h2 class="fw-bold mb-2 text-uppercase">Sign in to Smart IMG</h2>
                <p class="mb-5">By signing in, you are authorizing Google to control your devices</p>
              </div>

              <div class="mb-md-4 mt-md-4 d-grid gap-2">
                <button class="btn btn-outline-secondary w-100" type="button" (click)="socialLogin('GOOGLE')">
                  Continue with Google
                </button>
                <button class="btn btn-outline-secondary w-100" type="button" (click)="socialLogin('APPLE')">
                  Continue with Apple
                </button>
                <!-- Facebook login intentionally disabled -->
                <!--
                <button class="btn btn-outline-secondary w-100" type="button" (click)="socialLogin('FACEBOOK')">
                  Continue with Facebook
                </button>
                -->
              </div>

              <div class="text-center my-3 text-muted">or</div>

              <div class="mb-md-5 mt-md-4">

                <div class="form-outline form-white mb-4">
                  <label class="form-label" for="email">Email</label>
                  <input name="email" type="email" id="email" [(ngModel)]="email" class="form-control" required
                    autocomplete="username" />
                </div>

                <div class="form-outline form-white mb-4">
                  <label class="form-label" for="password">Password</label>
                  <input name="password" type="password" id="password" [(ngModel)]="password" class="form-control"
                    required autocomplete="current-password" />
                </div>

              </div>

              <div class="mb-md-5 mt-md-4">
                <button class="btn btn-secondary w-100" [disabled]="!loginForm.valid" type="submit">Login</button>
              </div>

            </form>

            }

            @if (pageState == pageStateEnum.CONFIRM_OAUTH) {

            <div class="mb-md-5 mt-md-4 text-center">
              <img src="assets/images/logo-small.png" alt="Logo" class="logo rounded mb-4" />
              <h2 class="fw-bold mb-2 text-uppercase">Link Smart IMG with Google</h2>
            </div>

            <div class="mb-md-5 mt-md-4">
              <p>Signed in as {{email}} (<a (click)="signOut()" class="text-primary text-decoration-underline">sign
                  out</a>)</p>
            </div>
            <hr>
            <div class="mb-md-5 mt-md-4">
              <p>Smart IMG will be able to:</p>
              <ul>
                <li>Access your email address</li>
                <li>Control your devices</li>
                <li>Receive notifications about your devices</li>
              </ul>
            </div>
            <hr>
            <div class="mb-md-5 mt-md-4">
              <p>Review Google's <a href="https://policies.google.com/">Privacy Policy</a></p>
            </div>


            <div class="row mb-md-5 mt-md-4 text-center">
              <div class="col-6">
                <button class="btn btn-outline-secondary w-100" type="button" (click)="signOut()">Cancel</button>
              </div>
              <div class="col-6">
                <button class="btn btn-secondary w-100" type="button" [disabled]="!hasOAuthRequest"
                  (click)="confirmOAuth()">Agree</button>
              </div>
            </div>

            }


            @if (errorMessage) {
            <div class="mt-5 alert alert-danger" role="alert">
              {{ errorMessage }}
            </div>
            }

          </div>

        </div>

      </div>

    </div>

  </div>

</section>